export default "__VITE_ASSET__B41N2QhY__"